import { m } from "@vega-core/paraglide/messages";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

import { useNotificationCenter } from "../NotificationCenter.context";

type Props = {
  className?: string;
  format?: (shown: number, total: number) => string;
};

const defaultFormat = (shown: number, total: number) =>
  shown >= total
    ? m.notificationCenter_countShownAll({ total })
    : m.notificationCenter_countShown({ shown, total });

export const NotificationCenterCount = ({
  className,
  format = defaultFormat,
}: Props) => {
  const { items, totalCount, isLoading, error } = useNotificationCenter();
  const resolvedTotal = totalCount ?? items.length;

  if (items.length === 0 && (isLoading || error)) return null;

  if (resolvedTotal === 0) return null;

  return (
    <p
      className={cnTwMerge(
        "shrink-0 body-extra-small-regular text-text/secondary text-center py-3 border-t-1 border-border/primary bg-background/card",
        className,
      )}
      data-testid="notification-center-count"
    >
      {format(items.length, resolvedTotal)}
    </p>
  );
};
